import React, { Component } from 'react';

class SidebarMinimizer extends Component {

  sidebarMinimize() {
    document.body.classList.toggle('sidebar-minimized');
  }

  brandMinimize() {
    document.body.classList.toggle('brand-minimized');
  }

  render() {
    return (
      <button className="sidebar-minimizer" type="button"
        style={{
          background: "rgba(0,0,0,0.15)",
          border: "none",
          borderTop: "1px solid rgba(255,255,255,0.06)",
          transition: "all 0.25s ease"
        }}
        onClick={(event) => { this.sidebarMinimize(); this.brandMinimize() }}>
      </button>
    )
  }
}

export default SidebarMinimizer;



// WEBPACK FOOTER //
// ./src/components/SidebarMinimizer/SidebarMinimizer.js